import { Chip } from "@heroui/react";
import { useState, useEffect } from "react";
import { TicketCategory } from "@/api/tickets/tickets.ts";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function CategoryChip({ categoryId }: { categoryId: number }) {
  const [item, setItem] = useState<TicketCategory | null>(null);
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  useEffect(() => {
    if (categoryId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == categoryId) || null);
    }
  }, [categoryId, items]);

  return (
    <>
      {categoryId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {categoryId !== -1 && item !== null && (
        <Chip className="cursor-pointer" variant="dot" color="primary">
          {item?.display_name}
        </Chip>
      )}
      {categoryId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
